import React, { useMemo } from 'react';
import InitialSeedPageHeader from 'components/rfq/product-template/initial-seed-product-templates/PageHeader';
import InitialSeedProductTemplatesStore, {
  PageStoreContext,
} from 'store/pages/rfq/rfq-template/initial-seed-product-templates/pageStore';
import InitialSeedProductTemplatesTable from 'components/rfq/product-template/initial-seed-product-templates/InitialSeedProductTemplatesTable';
import ActionPanel from 'components/rfq/product-template/initial-seed-product-templates/InitialSeedProductTemplatesTable/ActionPanel';
import { PageWrapperStyled } from './styles';

const InitialSeedProductTemplatesPage: React.FC = () => {
  const pageStore = useMemo(() => new InitialSeedProductTemplatesStore(), []);

  return (
    <PageWrapperStyled>
      <PageStoreContext.Provider value={pageStore}>
        <InitialSeedPageHeader />
        <ActionPanel />
        <InitialSeedProductTemplatesTable />
      </PageStoreContext.Provider>
    </PageWrapperStyled>
  );
};

export default InitialSeedProductTemplatesPage;
